import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "menu-control";

const GET_USER_MENU_URL = `${prefix}/get-user-menu`;
const GET_ALL_MENU_URL = `${prefix}/all`;
const CREATE_MENU_URL = `${prefix}/create`;
const UPDATE_MENU_BY_ID_URL = `${prefix}/update`;
const DELETE_MENU_BY_ID_URL = `${prefix}/delete`;

/**
 * @func getUserMenu
 * @desc get user menu
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} menu array
 */
export const getUserMenu = async signal => {
    try {
        const { data, status } = await axios.get(GET_USER_MENU_URL, {
            signal,
        });
        if (status === 200) {
            return data?.data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getUserMenu");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getUserMenu */

/**
 * @func getAllMenu
 * @desc get all menu data
 * @author izeberg
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} menu array
 */
export const getAllMenu = async signal => {
    try {
        const { data, status } = await axios.get(GET_ALL_MENU_URL, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getAllMenu");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getAllMenu */

/**
 * Start
 * @func createMenu
 * @desc create new menu
 * @author izeberg
 * @param {Object} body - create menu body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} cnew menu
 */
export const createMenu = async (body, signal) => {
    try {
        const { data, status } = await axios.post(CREATE_MENU_URL, body, {
            signal,
        });
        if (status === 201) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "createMenu");
        if (err) throw err;
        return undefined;
    }
};
/** End @func createMenu */

/**
 * Start
 * @func updateMenuById
 * @desc update menu by id
 * @author izeberg
 * @param {number} id - menu id
 * @param {Object} body - update menu body
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} menu object
 */
export const updateMenuById = async (id, body, signal) => {
    try {
        const { data, status } = await axios.put(`${UPDATE_MENU_BY_ID_URL}/${id}`, body, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "updateMenuById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func updateMenuById */

/**
 * Start
 * @func deleteMenuById
 * @desc delete menu by id
 * @author izeberg
 * @param {number} id - menu id
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Object} delete status
 */
export const deleteMenuById = async (id, signal) => {
    try {
        const { data, status } = await axios.delete(`${DELETE_MENU_BY_ID_URL}/${id}`, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "deleteMenuById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func deleteMenuById */
